import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { modalsActions } from './state';
import { ModalId } from './types';

class ModalsModule extends AppModule {
  /**
   * Opens a modal by its ID with the provided props.
   * @param modalId - The unique ID of the modal to open.
   * @param props - The props to pass to the modal.
   */
  public openModal(modalId: ModalId, props: Record<string, any> = {}) {
    modalsActions.openModal(modalId, props);
  }

  /**
   * Closes the currently active modal.
   */
  public closeActiveModal() {
    modalsActions.closeModal();
  }
}

export default new ModalsModule(appManager.events, appManager.logger('Modals'));
